import uiRouter from '@uirouter/angularjs/lib-esm'
/*import user from '../SlotTrak.User'*/

import loginRoutes from './routes'

const loginComponent = require("./Pages/login/index")

var mod = angular.module('SlotTrak.Login', [
  uiRouter,
  /*user*/
])

mod
  .config(loginRoutes)
  .component(loginComponent.vsComponentName, loginComponent.loginPageComponentOptions)
  .directive(loginComponent.externalLoginFlow.vsDirectiveName, loginComponent.externalLoginFlow.externalLoginFlow)

export default mod.name
